import * as m from '~/paraglide/messages'
import type { ActionPushStatus } from './action-status'

const dayFormats = new Map<'de' | 'en', Intl.DateTimeFormat>()

/** A calendar day (YYYY-MM-DD) as "Sonntag, 18. Oktober" / "Sunday 18 October". */
export function actionDayLabel(date: string, locale: 'de' | 'en'): string {
  let format = dayFormats.get(locale)
  if (!format) {
    format = new Intl.DateTimeFormat(locale === 'de' ? 'de-AT' : 'en-GB', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    })
    dayFormats.set(locale, format)
  }
  return format.format(new Date(`${date}T12:00:00Z`))
}

export function actionStatusText(status: ActionPushStatus): string {
  switch (status.kind) {
    case 'sent':
      if (status.count === 0) return m.actionStatusSentNone()
      return status.count === 1
        ? m.actionStatusSentOne()
        : m.actionStatusSent({ count: status.count })
    case 'sending':
      return m.actionStatusSending()
    case 'morning':
      return m.actionStatusMorning()
    case 'never':
      return m.actionStatusNever()
    case 'missed':
      return m.actionStatusMissed()
  }
}
